import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    staticClass: "page"
  }, [_c("template", {
    slot: "header"
  }, [_c("el-page-header", {
    attrs: {
      content: "《 " + _vm.currentCourse.title + " 》 课时列表"
    },
    on: {
      back: _vm.back
    }
  }), _c("el-form", {
    attrs: {
      inline: true,
      size: "mini"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "关键字"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "关键字"
    },
    model: {
      value: _vm.searchForm.searchKey,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "searchKey", $$v);
      },
      expression: "searchForm.searchKey"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.search
    }
  }, [_c("i", {
    staticClass: "fa fa-search"
  }), _vm._v(" 查询")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.add
    }
  }, [_c("i", {
    staticClass: "fa fa-plus"
  }), _vm._v(" 添加")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.queryLoading,
      expression: "queryLoading"
    }],
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      border: "",
      "row-key": "id",
      "element-loading-text": "正在努力加载中..."
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      type: "index",
      width: "90"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "145"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.edit(scope.row.id);
            }
          }
        }, [_vm._v("编辑")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "danger"
          },
          on: {
            click: function click($event) {
              return _vm.del(scope.row.id);
            }
          }
        }, [_vm._v("删除")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "title",
      label: "标题",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.title || ""))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "sort",
      label: "排序号",
      "show-overflow-tooltip": "",
      sortable: "custom",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.sort || ""))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "freeState",
      label: "免费",
      "show-overflow-tooltip": "",
      sortable: "custom",
      width: "75"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.freeState ? _c("span", {
          staticClass: "text-suggest"
        }, [_vm._v("免费")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "playAmount",
      label: "播放量",
      "show-overflow-tooltip": "",
      sortable: "custom",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.playAmount || 0))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "videoLength",
      label: "视频时长",
      "show-overflow-tooltip": "",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.videoLength || ""))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "audioLength",
      label: "音频时长",
      "show-overflow-tooltip": "",
      width: "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.audioLength || ""))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "remark",
      label: "简介",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.remark || ""))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "createTime",
      label: "创建时间",
      sortable: "custom",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.createTime ? _vm.dayjs(scope.row.createTime * 1000).format("YYYY-MM-DD HH:mm:ss") : ""))])];
      }
    }])
  })], 1), _c("el-pagination", {
    attrs: {
      background: "",
      align: "center",
      layout: "prev, pager, next, sizes, total",
      "page-sizes": [10, 20, 50, 100],
      "current-page": _vm.searchForm.page,
      "page-size": _vm.searchForm.limit,
      total: _vm.totalCount
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.sizeChange
    }
  }), _c("el-dialog", {
    attrs: {
      visible: _vm.editDialogShow,
      title: _vm.editDialogTitle,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.editDialogShow = $event;
      },
      close: function close($event) {
        return _vm.initFormData(_vm.emptyFormData);
      }
    }
  }, [_c("el-form", {
    ref: "formDataVerify",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "标题",
      "label-width": _vm.formLabelWidth,
      prop: "title"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "标题"
    },
    model: {
      value: _vm.formData.title,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "title", $$v);
      },
      expression: "formData.title"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "排序",
      "label-width": _vm.formLabelWidth,
      prop: "sort"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "排序号"
    },
    model: {
      value: _vm.formData.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "sort", $$v);
      },
      expression: "formData.sort"
    }
  })], 1)], 1)], 1), _c("el-row", [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "免费",
      "label-width": _vm.formLabelWidth,
      prop: "freeState"
    }
  }, [_c("el-radio", {
    attrs: {
      label: true
    },
    model: {
      value: _vm.formData.freeState,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "freeState", $$v);
      },
      expression: "formData.freeState"
    }
  }, [_vm._v("是")]), _c("el-radio", {
    attrs: {
      label: false
    },
    model: {
      value: _vm.formData.freeState,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "freeState", $$v);
      },
      expression: "formData.freeState"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _c("el-row", [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "上传类型",
      "label-width": _vm.formLabelWidth
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: "请选择",
      clearable: ""
    },
    model: {
      value: _vm.VideoOrAudio,
      callback: function callback($$v) {
        _vm.VideoOrAudio = $$v;
      },
      expression: "VideoOrAudio"
    }
  }, [_c("el-option", {
    attrs: {
      label: "音频+视频",
      value: "VideoAndAudio"
    }
  }), _c("el-option", {
    attrs: {
      label: "只有视频",
      value: "onlyVideo"
    }
  }), _c("el-option", {
    attrs: {
      label: "只有音频",
      value: "onlyAudio"
    }
  })], 1)], 1)], 1)], 1), _vm.VideoOrAudio === "VideoAndAudio" || _vm.VideoOrAudio === "onlyVideo" ? _c("el-row", [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "video",
    attrs: {
      label: "视频",
      "label-width": _vm.formLabelWidth,
      prop: "video"
    }
  }, [!_vm.formData.video ? _c("el-upload", {
    staticClass: "avatar-uploader",
    attrs: {
      action: "",
      accept: "'video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb'",
      "list-type": "picture-card",
      "show-file-list": false,
      "before-upload": _vm.beforeFileUpload,
      "http-request": _vm.uploadVideo
    }
  }, [_c("i", {
    staticClass: "el-icon-plus"
  })]) : _vm._e(), _vm.formData.video ? _c("div", {
    staticClass: "el-upload-list el-upload-list--picture-card"
  }, [_c("div", {
    staticClass: "el-upload-list__item is-success"
  }, [_vm.formData.video ? _c("video", {
    staticClass: "avatar",
    staticStyle: {
      width: "100%",
      height: "100%"
    },
    attrs: {
      src: _vm.formData.video
    }
  }) : _vm._e(), _c("label", {
    staticClass: "el-upload-list__item-status-label"
  }, [_c("i", {
    staticClass: "el-icon-upload-success el-icon-check"
  })]), _c("span", {
    staticClass: "el-upload-list__item-actions"
  }, [_c("span", {
    staticClass: "el-upload-list__item-delete"
  }, [_c("i", {
    staticClass: "el-icon-delete",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.removeVideo();
      }
    }
  })]), _c("span", {
    staticClass: "el-upload-list__item-delete"
  }, [_c("i", {
    staticClass: "el-icon-video-play",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.previewFile(_vm.formData.video);
      }
    }
  })])])])]) : _vm._e()], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "视频长度",
      "label-width": _vm.formLabelWidth,
      prop: "videoLength"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "视频长度",
      disabled: ""
    },
    model: {
      value: _vm.formData.videoLength,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "videoLength", $$v);
      },
      expression: "formData.videoLength"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "视频秒数",
      "label-width": _vm.formLabelWidth,
      prop: "videoTrackLength"
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "45%"
    },
    attrs: {
      autocomplete: "off",
      placeholder: "视频秒数",
      disabled: ""
    },
    model: {
      value: _vm.formData.videoTrackLength,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "videoTrackLength", $$v);
      },
      expression: "formData.videoTrackLength"
    }
  }), _vm._v(" 秒 ")], 1)], 1)], 1) : _vm._e(), _vm.VideoOrAudio === "VideoAndAudio" || _vm.VideoOrAudio === "onlyAudio" ? _c("el-row", [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    staticClass: "video",
    attrs: {
      label: "音频",
      "label-width": _vm.formLabelWidth,
      prop: "audio"
    }
  }, [!_vm.formData.audio ? _c("el-upload", {
    staticClass: "avatar-uploader",
    attrs: {
      action: "",
      accept: "'audio/mpeg', 'audio/ogg', 'application/ogg'",
      "list-type": "picture-card",
      "show-file-list": false,
      "before-upload": _vm.beforeAudioUpload,
      "http-request": _vm.uploadAudio
    }
  }, [_c("i", {
    staticClass: "el-icon-plus"
  })]) : _vm._e(), _vm.formData.audio ? _c("div", {
    staticClass: "el-upload-list el-upload-list--picture-card"
  }, [_c("div", {
    staticClass: "el-upload-list__item is-success"
  }, [_vm.formData.audio ? _c("video", {
    staticClass: "avatar",
    staticStyle: {
      width: "100%",
      height: "100%"
    },
    attrs: {
      src: _vm.formData.audio
    }
  }) : _vm._e(), _c("label", {
    staticClass: "el-upload-list__item-status-label"
  }, [_c("i", {
    staticClass: "el-icon-upload-success el-icon-check"
  })]), _c("span", {
    staticClass: "el-upload-list__item-actions"
  }, [_c("span", {
    staticClass: "el-upload-list__item-delete"
  }, [_c("i", {
    staticClass: "el-icon-delete",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.removeAudio();
      }
    }
  })]), _c("span", {
    staticClass: "el-upload-list__item-delete"
  }, [_c("i", {
    staticClass: "el-icon-video-play",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.previewFile(_vm.formData.audio);
      }
    }
  })])])])]) : _vm._e()], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "音频长度",
      "label-width": _vm.formLabelWidth,
      prop: "audioLength"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "音频长度",
      disabled: ""
    },
    model: {
      value: _vm.formData.audioLength,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "audioLength", $$v);
      },
      expression: "formData.audioLength"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "音频秒数",
      "label-width": _vm.formLabelWidth,
      prop: "audioTrackLength"
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "45%"
    },
    attrs: {
      autocomplete: "off",
      placeholder: "音频秒数",
      disabled: ""
    },
    model: {
      value: _vm.formData.audioTrackLength,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "audioTrackLength", $$v);
      },
      expression: "formData.audioTrackLength"
    }
  }), _vm._v(" 秒 ")], 1)], 1)], 1) : _vm._e(), _c("el-row", [_c("el-col", [_c("el-form-item", {
    attrs: {
      label: "附件",
      "label-width": _vm.formLabelWidth,
      prop: "attachment"
    }
  }, [_c("el-upload", {
    staticClass: "document-uploader",
    attrs: {
      action: "#",
      "list-type": "picture-card",
      "show-file-list": false,
      "http-request": _vm.uploadPdf
    }
  }, [!_vm.formData.attachment ? _c("i", {
    staticClass: "el-icon-plus"
  }) : _c("div", {
    staticClass: "document-info"
  }, [_c("span", {
    staticClass: "document-name"
  }, [_c("i", {
    staticClass: "el-icon-document"
  })]), _c("div", {
    staticClass: "close",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.pdfDel.apply(null, arguments);
      }
    }
  }, [_vm._v("×")])])])], 1)], 1)], 1), _c("el-row", [_c("el-col", [_c("el-form-item", {
    attrs: {
      label: "简介",
      "label-width": _vm.formLabelWidth,
      prop: "remark"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 5
    },
    model: {
      value: _vm.formData.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "remark", $$v);
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.closeEditDialogShow
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitFormData
    }
  }, [_vm._v("确 定")])], 1)], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };